import cn from 'classnames';
import { RC_DURATION } from '@lambda/reebelo';
import { generateProductWarrantySavings } from '@/lib/reebelocare/helpers';
import { priceFormater } from '@/settings/index';
import { ProductWarrantyT } from '@/lib/reebelocare/types';
import settings from '@/settings';

const USLineItem = ({
  productWarranty,
  checked,
  duration,
  isCheckingOut,
  handleToggle,
}: {
  productWarranty: ProductWarrantyT;
  checked: RC_DURATION | null;
  duration: RC_DURATION;
  isCheckingOut: boolean;
  handleToggle: (duration: RC_DURATION) => void;
}) => {
  const savings = generateProductWarrantySavings(productWarranty);

  const isChecked = checked === duration;
  const isCA = settings.store === 'reebelo-ca';

  const itemPrice = productWarranty[duration]?.price ?? 0;

  const itemMonthlyPrice = itemPrice
    ? priceFormater.long(itemPrice / Number(duration))
    : 0;

  return (
    <button
      className={
        'group flex w-full items-center justify-between gap-2 rounded-md border p-3 outline-none disabled:opacity-30'
      }
      disabled={isCheckingOut}
      type="button"
      onClick={() => handleToggle(duration)}
    >
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'flex h-4 w-4 shrink-0 items-center justify-center rounded border',
            {
              'border-gray-700/30 group-hover:border-gray-700': !isChecked,
              'border-gray-700': isChecked,
            },
          )}
        >
          {isChecked && (
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.79037 0.580566L2.95703 6.41973L1.20703 4.66973"
                stroke="#1F2323"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <h4 className="flex items-center justify-center text-left text-sm font-bold">
            {duration}-Months{isCA ? ' Protection' : "' Protection"}
          </h4>
          {savings && duration === RC_DURATION['24_MONTH'] && (
            <div className="rounded bg-[#116A43] py-1.5 px-1.5 text-xs font-bold text-white xs:px-3">
              Save {savings}%
            </div>
          )}
        </div>
      </div>
      <div className="text-left leading-tight">
        <span className="text-sm">
          {priceFormater.long(itemPrice)} ({itemMonthlyPrice}/mo)
        </span>
      </div>
    </button>
  );
};

export default USLineItem;
